import type { Owner } from "solid-js";
import { createSignal } from "solid-js";

const [owner, setOwner] = createSignal<Owner | null>(null);

export default owner;
export { setOwner };
